export const PAGE_SCALE_STEP = 0.25;
export const PAGE_SCALE_MIN_VALUE = 0.5;
export const PAGE_SCALE_MAX_VALUE = 10.0;

// Bundle review has a smooth-zoom transition (snapshot overlay + CSS scale)
// that hides the cost of larger jumps, so it uses a coarser step and a higher
// floor. Retrieve Pages and the GDPR page use the shared values above.
export const BUNDLE_PAGE_SCALE_STEP = 0.5;
export const BUNDLE_PAGE_SCALE_MIN_VALUE = 0.75;
